/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState } from 'react';
import {
    object, shape, arrayOf, string, func,
} from 'prop-types';
import { useUIDSeed } from 'react-uid';
import withStyles from '@material-ui/core/styles/withStyles';
import Button from '@material-ui/core/Button';
import ToolbarList from './ToolbarList';

const styles = (theme) => ({
    root: {
        position: 'relative',
        background: theme.palette.cgc?.toolboxBackground || 'linear-gradient(90deg, #F3F3F3 0%, #D3D3D3 100%)',
        padding: '5px 20px',
        borderRadius: '10px',
        marginBottom: '10px',
        color: theme.palette.cgc?.toolboxColor || '#000',
        '& .MuiButton-label': {
            display: 'inline-grid',
        },
        [theme.breakpoints.down(1660)]: {
            padding: 0,
        },
    },
    labelText: {
        fontSize: '1rem',
        textTransform: 'none',
        fontFamily: 'roboto',
        fontWeight: 300,
        lineHeight: '20px',
    },
});

const Toolbar = ({
    classes,
    config,
    setStyle,
}) => {
    const seed = useUIDSeed();
    const [listData, setListData] = useState(false);
    const [showList, setShowList] = useState(true);

    const handleButtonClick = (tool) => {
        if (tool?.list?.length > 0) {
            setListData(tool);
            setShowList(true);
        } else {
            setStyle(tool?.type, tool?.value);
        }
    };
    const handleList = () => {
        setShowList(false);
    };
    return (
        <>
            <div className={classes.root}>
                {(config || []).map((tool) => (
                    <>
                        <Button
                            key={seed(config)}
                            onClick={() => handleButtonClick(tool)}
                        >
                            <span className={classes.icon}>{tool?.icon || null}</span>
                            <span className={classes.labelText}>{tool?.label}</span>
                        </Button>
                    </>
                ))}
            </div>

            {listData?.list?.length ? <ToolbarList tool={listData} onClick={setStyle} handleList={handleList} showList={showList} /> : null}
        </>
    );
};

Toolbar.propTypes = {
    classes: object.isRequired,
    setStyle: func,
    config: arrayOf(shape({
        value: string,
        label: string,
        icon: string,
        title: string,
        type: string,
        list: arrayOf(shape({
            label: string,
            value: string,
        })),
    })),
};

Toolbar.defaultProps = {
    config: {},
    setStyle: {},
};

export default withStyles(styles)(Toolbar);
